import * as apiService from "./apiService";
import {
  WIDGET_PUBLIC,
  GET_PROPERTY_TYPE,
  GET_FINANCE_TYPE,
  GET_PLAN_TO_BUY,
  GET_PURCHASE_TYPE,
} from "../../constants/v2/endPoints";

// Public, key-scoped widget API (no JWT; gating is server-side by widgetKey).

export async function getWidgetConfig(widgetKey) {
  return await apiService.apiCallWithoutToken(
    `${WIDGET_PUBLIC}/${encodeURIComponent(widgetKey)}/config`,
    "GET",
    {},
  );
}

export async function getWidgetWantAds(widgetKey, { sortType, page } = {}) {
  const params = {};
  if (sortType) params.sortType = sortType;
  if (page) params.page = page;
  return await apiService.apiCallWithoutToken(
    `${WIDGET_PUBLIC}/${encodeURIComponent(widgetKey)}/wantads`,
    "GET",
    params,
  );
}

// GET /api/v2/widget/:widgetKey/wantads with the full search/filter query -
// a superset of getWidgetWantAds's params. Kept as a separate function
// (rather than widening getWidgetWantAds) so the existing chrome-less widget
// keeps its narrower, already-shipped contract untouched.
export async function getWidgetSearchFeed(widgetKey, params = {}) {
  return await apiService.apiCallWithoutToken(
    `${WIDGET_PUBLIC}/${encodeURIComponent(widgetKey)}/wantads`,
    "GET",
    params,
  );
}

// Reference lists (property type / finance type / timeline / purchase type)
// for the search widget's filter chips. These are the same public
// api/master/* endpoints the main feed's filter panel uses
// (LeftpanelTabContent.js) - server-side they require the global api-key but
// skip JWT entirely (see Gitcha-API's PUBLIC_ROUTES), so they're safe to call
// anonymously from the embed. BUY-scoped: the widget shows the whole MLS
// regardless of buy/rent, and property-type options only meaningfully differ
// by that axis, so BUY is the stable default rather than adding an adType
// toggle the widget doesn't otherwise have.
export async function getWidgetFilterOptions() {
  const [propertyTypes, financeTypes, timelines, purchaseTypes] =
    await Promise.all([
      apiService.apiCallWithoutToken(`${GET_PROPERTY_TYPE}?Type=buy`, "GET", {}),
      apiService.apiCallWithoutToken(GET_FINANCE_TYPE, "GET", {}),
      apiService.apiCallWithoutToken(`${GET_PLAN_TO_BUY}?Type=buy`, "GET", {}),
      apiService.apiCallWithoutToken(GET_PURCHASE_TYPE, "GET", {}),
    ]);

  const results = (res) => (res?.errorCode === 0 ? res.result || [] : []);

  return {
    propertyTypes: results(propertyTypes).map((t) => ({
      id: String(t.PropertyTypeId),
      label: t.PropertyTypeText,
    })),
    financeTypes: results(financeTypes).map((t) => ({
      id: String(t.FinanceTypeId),
      label: t.FinanceTypeText,
    })),
    timelines: results(timelines).map((t) => ({
      id: String(t.TimeLineId),
      label: t.TimeLineText,
    })),
    purchaseTypes: results(purchaseTypes).map((t) => ({
      id: String(t.PurchaseTypeId),
      label: t.PurchaseTypeText,
    })),
  };
}
